<script setup lang="ts">
import { isVNode } from 'vue';
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from '.';
import { useToast } from './use-toast';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/solid';

const { toasts } = useToast();
</script>

<template>
  <ToastProvider swipe-direction="down">
    <Toast
      v-for="toast in toasts"
      :key="toast.id"
      v-bind="toast"
      class="flex max-md:flex-col max-md:gap-4 print:hidden"
    >
      <div class="flex flex-col">
        <ToastTitle v-if="toast.title" class="flex items-center justify-start gap-2">
          <XCircleIcon v-if="toast.variant === 'destructive'" class="size-5 stroke-2" />
          <CheckCircleIcon v-else class="size-5 stroke-2" />
          {{ toast.title }}
        </ToastTitle>

        <template v-if="toast.description">
          <ToastDescription v-if="isVNode(toast.description)">
            <component :is="toast.description" />
          </ToastDescription>
          <ToastDescription v-else>
            {{ toast.description }}
          </ToastDescription>
        </template>
        <ToastClose />
      </div>
      <component :is="toast.action" />
    </Toast>
    <ToastViewport />
  </ToastProvider>
</template>
